(function () {
  'use strict';

  const FLOCAGE = {
    NOM_NUM_VARIANT_ID: 62668663390538,
    PATCH_VARIANT_ID: 62668663456074,
  };

  let priceEl = null, priceBaseCents = null, ourUpdate = false, lastSup = 0, hookBusy = false;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const root = document.querySelector('[data-flocage-root]');
    if (!root) return;
    const inputName = root.querySelector('[data-flocage-input="name"]');
    const inputNumber = root.querySelector('[data-flocage-input="number"]');
    const patchCheckbox = root.querySelector('[data-flocage-patch-checkbox]');
    const totalNode = root.querySelector('[data-flocage-total] strong');
    if (!inputName || !inputNumber || !patchCheckbox || !totalNode) return;

    initPriceEl();

    inputName.addEventListener('input', updateAll);
    inputNumber.addEventListener('input', updateAll);
    patchCheckbox.addEventListener('change', updateAll);

    function hasNomOrNum() {
      if (inputName.value.trim().length > 0) return true;
      const n = parseInt(inputNumber.value, 10);
      return Number.isFinite(n) && n >= 0 && n <= 99;
    }
    function calcSup() {
      let s = 0;
      if (hasNomOrNum()) s += 1000;
      if (patchCheckbox.checked) s += 500;
      return s;
    }
    function updateAll() {
      const s = calcSup();
      lastSup = s;
      totalNode.textContent = (s / 100).toFixed(0) + ' €';
      updatePriceDisplay(s);
    }

    if (priceEl) {
      const obs = new MutationObserver(function () {
        if (ourUpdate) return;
        readBasePrice();
        updatePriceDisplay(lastSup);
      });
      obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    hookAddToCartClick();
  }

  function initPriceEl() {
    priceEl = document.querySelector('.price:not(.price--sold-out) .price-item--sale')
           || document.querySelector('.price:not(.price--sold-out) .price-item--regular')
           || document.querySelector('.price-item--sale')
           || document.querySelector('.price-item--regular');
    if (priceEl) readBasePrice();
  }
  function readBasePrice() {
    if (!priceEl) return;
    const t = priceEl.textContent || '';
    const m = t.replace(/[^\d,.]/g, '').match(/[\d,.]+/);
    if (!m) return;
    const s = m[0].replace(/\./g, '').replace(',', '.');
    const v = parseFloat(s);
    if (Number.isFinite(v)) priceBaseCents = Math.round(v * 100);
  }
  function updatePriceDisplay(sup) {
    if (!priceEl || priceBaseCents === null) return;
    ourUpdate = true;
    const t = priceBaseCents + sup;
    priceEl.textContent = '€' + (t / 100).toFixed(2).replace('.', ',') + ' EUR';
    setTimeout(function () { ourUpdate = false; }, 20);
  }

  function generateBundleId() {
    return 'floc-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function hookAddToCartClick() {
    document.addEventListener('click', async function (event) {
      if (hookBusy) return;
      const btn = event.target.closest('button[name="add"], button[type="submit"]');
      if (!btn) return;
      const form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;
      const root = document.querySelector('[data-flocage-root]');
      if (!root) return;
      const inputName = root.querySelector('[data-flocage-input="name"]');
      const inputNumber = root.querySelector('[data-flocage-input="number"]');
      const patchCheckbox = root.querySelector('[data-flocage-patch-checkbox]');
      if (!inputName || !inputNumber || !patchCheckbox) return;

      const nameVal = inputName.value.trim().toUpperCase();
      const num = parseInt(inputNumber.value, 10);
      const numValid = Number.isFinite(num) && num >= 0 && num <= 99;
      const hasNomNum = nameVal.length > 0 || numValid;
      const hasPatch = patchCheckbox.checked;
      if (!hasNomNum && !hasPatch) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      hookBusy = true;
      btn.setAttribute('aria-busy', 'true');

      try {
        const bundleId = generateBundleId();
        const fd = new FormData(form);
        const variantId = parseInt(fd.get('id'), 10);
        const quantity = parseInt(fd.get('quantity') || '1', 10);

        // Properties visibles sur la ligne maillot (récap commande + email + admin)
        const mainProps = {};
        fd.forEach(function (v, k) {
          const m = k.match(/^properties\[(.+)\]$/);
          if (m && v) mainProps[m[1]] = v;
        });
        if (nameVal.length > 0) mainProps['Nom flocage'] = nameVal;
        if (numValid) mainProps['Numéro flocage'] = String(num);
        if (hasPatch) mainProps['Patch flocage'] = patchCheckbox.value;

        // Attribut _flocage_bundle : partagé maillot + fantômes
        // Utilisé côté Cart Transform Function si USC passe Plus un jour
        mainProps['_flocage_bundle'] = bundleId;

        const items = [{ id: variantId, quantity: quantity, properties: mainProps }];

        if (hasNomNum) {
          items.push({
            id: FLOCAGE.NOM_NUM_VARIANT_ID,
            quantity: 1,
            properties: { '_flocage_bundle': bundleId, '_hidden_flocage': '1' },
          });
        }
        if (hasPatch) {
          items.push({
            id: FLOCAGE.PATCH_VARIANT_ID,
            quantity: 1,
            properties: { '_flocage_bundle': bundleId, '_hidden_flocage': '1' },
          });
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
        if (!res.ok) {
          const e = await res.text();
          throw new Error('Cart /add ' + res.status + ' — ' + e);
        }
        window.location.href = '/cart';
      } catch (err) {
        console.error('[flocage-usc] add.js failed', err);
        alert('Impossible d\'ajouter au panier avec la personnalisation. Détails console.');
        hookBusy = false;
        btn.removeAttribute('aria-busy');
      }
    }, true);
  }
})();
